var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAnc = function SvgIconAnc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.713c-4.97 0-9 4.038-9 9.022a9 9 0 0 0 1.055 4.243.5.5 0 1 1-.883.47A10.003 10.003 0 0 1 2 12.735C2 7.201 6.476 2.713 12 2.713S22 7.2 22 12.735a10 10 0 0 1-1.172 4.713.5.5 0 0 1-.883-.47q.08-.15.155-.305c.576-1.19.9-2.525.9-3.938 0-4.984-4.03-9.022-9-9.022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 15.213a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6M9.368 16.213c-2.35 0-4.368 1.694-4.368 3.91v.594c0 1.154 1.028 1.996 2.176 1.996h9.648c1.143 0 2.168-.842 2.176-1.987v-.604c0-2.215-2.018-3.91-4.368-3.91zM6 20.123c0-1.549 1.449-2.91 3.368-2.91h5.264c1.92 0 3.368 1.361 3.368 2.91v.598c-.004.495-.478.992-1.176.992H7.176c-.705 0-1.176-.498-1.176-.996z",
    clipRule: "evenodd"
  })));
};
export default SvgIconAnc;